import TopLayoutCareers from 'docs/src/modules/components/TopLayoutCareers';
import * as pageProps from 'docs/pages/careers/product-marketing-manager.md?muiMarkdown';

export default function Page() {
  return <TopLayoutCareers {...pageProps} />;
}
